import {
  BannerSplit as ComposableBannerSplit,
  BannerSplitProps,
} from '@oriuminc/ui'

export const BannerSplit = (props: BannerSplitProps) => {
  return <ComposableBannerSplit {...props} />
}
